import StatisticsCard from "@/components/dashboard/StatisticsCard";
import EmptyState from "@/components/dashboard/EmptyState";
import React from "react";
import { emptyStates, statistics } from "@/constants/content";

export default function Dashboard() {
  return (
    <div className="px-5 py-3 flex flex-column h-full overflow-auto gap-3">
      <div className="grid">
        {
          statistics?.map((stat) => (<div className="md:col-4 col-12">
          <StatisticsCard item={stat} />
        </div>))
        }
      </div>
      <EmptyState
        title={"RECENT TRACEABILITY"}
        route={"/"}
        icon="pi pi-refresh"
        desc={`Currently, there are no traceability flows added. \n
        Traceability flows will be displayed here once they are added.`}
      />
      <div className="grid mb-8">
        {emptyStates?.map((state) => (
          <div className="md:col-6 col-12">
            <EmptyState
              title={state.title}
              route={state.route}
              icon={state.icon}
              desc={state.desc}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
